import { useAPIQuery as n } from "./index.es385.js";
const i = ({ environment: e, token: s }) => n({
  queryKey: ["preset-dates"],
  token: s,
  environment: e,
  queryFn: async (t) => {
    const { getUserConfig: r } = t;
    return (await r()).configuration.cache_dates;
  },
  staleTime: 1 / 0
});
export {
  i as usePresetDates
};
//# sourceMappingURL=index.es348.js.map
